import React from 'react'
import { UI_STYLES } from "@/styles/uiStyles"

interface CardStatusBarProps {
  text: string
  isAvailable: boolean
}

const CardStatusBar: React.FC<CardStatusBarProps> = ({ text, isAvailable }) => (
  <div className={`w-full py-2 px-2 font-ubuntu font-light text-[11px] text-center text-white ${isAvailable ? UI_STYLES.cardStatusBarColorAvailable : UI_STYLES.cardStatusBarColor} rounded-t-xl`}>
    {text}
  </div>
)

export default CardStatusBar 
